import React from 'react';
import SEO from './SEO';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  canonicalUrl?: string;
  jsonLd?: object;
  ogImage?: string;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  description,
  canonicalUrl,
  jsonLd,
  ogImage,
}) => {
  return (
    <>
      {title && description && (
        <SEO
          title={title}
          description={description}
          canonicalUrl={canonicalUrl}
          jsonLd={jsonLd}
          ogImage={ogImage}
        />
      )}
      {children}
    </>
  );
};

export default Layout;
